import { render, staticRenderFns } from "./statistic.vue?vue&type=template&id=3e325c44&scoped=true"
import script from "./statistic.vue?vue&type=script&lang=js"
export * from "./statistic.vue?vue&type=script&lang=js"
import style0 from "./statistic.vue?vue&type=style&index=0&id=3e325c44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e325c44",
  null
  
)

export default component.exports